import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { GET_TICKET_TYPES } from '../../graphql/raffle';
import RaffleCard from './RaffleCard';
import RaffleDetail from './RaffleDetail';
import useMainStore from '../../store/mainState';

const periodOrder = ['daily', 'weekly', 'monthly'];

const Raffle = () => {
    const { t } = useTranslation();
    const { environment } = useMainStore();
    const { data: ticketTypesData, loading: typesLoading } = useQuery(GET_TICKET_TYPES, {
        variables: { environmentId: environment?.id },
        skip: !environment?.id,
    });
    const [selectedTicket, setSelectedTicket] = useState<{ ticket: any; period: string } | null>(null);

    const sortedTicketTypes = ticketTypesData?.ticketTypes
        ? [...ticketTypesData.ticketTypes].sort(
            (a: any, b: any) => periodOrder.indexOf(a.period.toLowerCase()) - periodOrder.indexOf(b.period.toLowerCase())
        )
        : [];

    // Group by period
    const groupedByPeriod: Record<string, any[]> = {};
    sortedTicketTypes.forEach((group: any) => {
        const period = group.period.toLowerCase();
        if (!groupedByPeriod[period]) groupedByPeriod[period] = [];
        groupedByPeriod[period].push(...(group.tickets || []));
    });

    // Detail view
    if (selectedTicket) {
        return (
            <RaffleDetail
                ticket={selectedTicket.ticket}
                period={selectedTicket.period}
                onBack={() => setSelectedTicket(null)}
            />
        );
    }

    // Main list view
    return (
        <div className="pb-[40px]">
            <div className="mb-[30px]">
                <h1 className="text-[28px] md:text-[36px] font-extrabold text-white tracking-tight">
                    {t('raffle.title')}
                </h1>
                <p className="text-white/30 text-[14px] mt-[4px]">{t('raffle.subtitle')}</p>
            </div>

            {typesLoading ? (
                <div className="flex items-center justify-center h-[200px]">
                    <div className="w-[44px] h-[44px] border-[3px] border-white/10 border-t-[#0086D3] rounded-full animate-spin"></div>
                </div>
            ) : (
                Object.entries(groupedByPeriod).map(([period, tickets]) => (
                    <div key={period} className="mb-[30px]">
                        <div className="flex items-center gap-[10px] mb-[16px]">
                            <div className="w-[3px] h-[20px] bg-gradient-to-b from-[#4DBDFF] to-[#0086D3] rounded-full"></div>
                            <h2 className="text-[18px] md:text-[22px] font-bold text-white capitalize tracking-tight">{period} {t('raffle.raffle')}</h2>
                        </div>
                        <div className="flex flex-col gap-[12px]">
                            {tickets.map((ticket: any) => (
                                <RaffleCard
                                    key={ticket.id}
                                    ticket={ticket}
                                    period={period}
                                    onClick={() => setSelectedTicket({ ticket, period })}
                                />
                            ))}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default Raffle;
